<template>
  <div :id="id"
       class="o-echarts">

  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import moment from 'moment'
let chart = null
export default {
  name: 'AreaPercentageChart',
  props: {
    id: {
      type: String,
      required: false,
      default: 'chart'
    },
    subtext: {
      type: String,
      required: false,
      default: moment().format('YYYY年MM月DD日')
    }

  },
  data () {
    return {
      // id: 'areaPercentageChart',//地图渲染容器id
      option: {

        title: {
          text: '',
          subtext: '(2020年5月6日)',
          left: 'right'
        },
        dataset: {
          // source:[
          // {
          //   'type':'水稻政策性保险',
          //   'labelValue':30
          //   },
          //    {
          //   'type':'大豆政策性保险',
          //   'labelValue':30
          //   },
          //    {
          //   'type':'玉米政策性保险',
          //   'labelValue':30
          //   },
          // ]
        },
        tooltip: {
          trigger: 'item',
          // formatter: "{a} <br/>{b} : {c} ({d}%)"
          formatter: function (params, ticket, callback) {
            return params.name + '<br>' + '面积：' + params.value.labelValue + '亩' + '<br>' + '占比：' + params.percent + '%'
            // return params.seriesName+' <br>'+params.name+': '+params.value.labelValue+' ('+params.percent+'%)';
          }
        },
        legend: {
          orient: 'vertical',
          right: '4%',
          top: '36%',
          bottom: 20,
          itemGap: 20,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#333'
          },
          icon: 'rect'
          // data: ["水稻政策性保险", "大豆政策性保险", "玉米政策性保险"]
        },
        color: ['#1a8dee', '#4ab2e9', '#13cdcc', '#ff9023'],
        series: [
          {
            name: '各险种投保面积比例（%）',
            type: 'pie',
            radius: [0, '60%'],
            center: ['30%', '50%'],
            label: {
              show: true,
              position: 'inside',
              fontSize: 16,
              formatter (params) {
                return params.percent + '%'
                // console.log("val:",val)
                // return val.value + "%";
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            encode: {
              itemName: 'type',
              value: 'labelValue'
            }
            // data: [
            //   { value: 30, name: "水稻政策性保险" },

            //   { value: 30, name: "大豆政策性保险" },

            //   { value: 30, name: "玉米政策性保险" }
            // ]
          }
        ]
      }
    }
  },
  mounted () {
    // this.initMap()
  },
  watch: {

  },
  methods: {
    listenResize () {
      // 窗口改变大小
      if (chart) {
        chart.resize()
      }
    },
    initMap (optionData) {
      // 设置时间
      this.option.title.subtext = optionData.date || ''
      this.option.dataset = optionData
      // this.option.series[0].data = optionData.series

      chart = echarts.init(
        document.getElementById(this.id)
      )
      chart.setOption(this.option)
    }

  },
  components: {

  }
}
</script>

<style scoped lang="less">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/AreaPercentageChart.vue